import { apiRequest } from './apiService';

// CRM Institutes
export const fetchCrmInstitutes = async () => {
  return await apiRequest('/crm/crm-institutes', 'GET');
};

export const createCrmInstitute = async (instituteData: any) => {
  return await apiRequest('/crm/crm-institutes', 'POST', instituteData);
};

export const fetchCrmInstitutesById = async (instituteId: any) => {
  return await apiRequest(`/crm/crm-institutes/${instituteId}`, 'GET');
};

export const updateCrmInstitute = async (
  instituteId: any,
  instituteData: any
) => {
  return await apiRequest(
    `/crm/crm-institutes/${instituteId}`,
    'PUT',
    instituteData
  );
};

export const deleteCrmInstitute = async (instituteId: any) => {
  return await apiRequest(`/crm/crm-institutes/${instituteId}`, 'DELETE');
};
